import React from "react";
import { TextField } from "@mui/material";
import type { SurveyQuestion } from "posthog-js";

/**
 * Props for the OpenQuestion component.
 */
export interface OpenQuestionProps {
  /** The SurveyQuestion object */
  question: SurveyQuestion;
  /** The current string value or null */
  value: string | null;
  /** Callback when the value changes */
  onChange: (value: string) => void;
}

/**
 * OpenQuestion Component
 * Renders an open-ended (free text) survey question.
 */
const OpenQuestion: React.FC<OpenQuestionProps> = ({
  question,
  value,
  onChange,
}) => {
  // Determine if the question is optional (used for placeholder and validation)
  const isOptional = "optional" in question && question.optional;

  return (
    <TextField
      multiline
      rows={3}
      fullWidth
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={isOptional ? "Optional" : "Your response..."}
      variant="outlined"
      size="small"
    />
  );
};

export default OpenQuestion;
